exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feature-item{padding:0;margin-right:30px;display:inline-block;vertical-align:top;width:270px;height:340px;background-color:#f8f8f8;border-bottom:4px solid #e5e6e6;text-align:center;border-radius:5px}.feature-item-content{margin-top:50px;height:260px}.feature-item-content>.feature-item-description{display:inline-block;font-size:13px;color:#777;margin:35px 27px 0;line-height:21px}.feature-item-content>.feature-item-heading{font-weight:800;font-size:16px;text-transform:uppercase;line-height:19px}.feature-item .image-content{margin:0 0 15px;display:inline-block;vertical-align:middle;width:inherit;height:auto;transform:translateY(50%);overflow:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-473db731","scoped":false,"hasInlineConfig":true}!./src/components/feature-item/feature-item.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-473db731","scoped":false,"hasInlineConfig":true}!./src/components/feature-item/feature-item.css
// module chunks = index